/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const AirplaneTakeOffBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21.907 9.66c-.15-.561-.68-.934-1.26-.872-.93.098-2.31.275-3.256.528l-2.735.733L6.89 3.552a.505.505 0 0 0-.455-.1l-.992.266a.5.5 0 0 0-.275.781l5.025 6.746-4.967 1.331-1.657-1.858a.504.504 0 0 0-.507-.15l-1.022.273a.5.5 0 0 0-.31.727l1.696 3.043c.5.642.75.963 1.071 1.071.323.109.717.003 1.505-.208l4.967-1.331 4.465-1.196 2.735-.733c.946-.254 2.228-.79 3.083-1.17.534-.237.806-.825.656-1.385ZM3 19a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h18a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H3Z" /></svg>);
const AirplaneTakeOff = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={AirplaneTakeOffBase} {...rest} ref={ref} />);
export default AirplaneTakeOff;